export default "__VITE_ASSET__DsoE08c5__"